import { Component, OnInit } from '@angular/core';
import { ReferralContact } from '../shared/models/referral-contacts';
import { firstValueFrom } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ReferralNotificationService } from '../shared/services/referral-notification.service';
import { UploadDocumentService } from '../shared/services/upload-document.service';
import { SnackbarService } from '../shared/services/snackbar.service';

@Component({
    selector: 'xp-notification',
    templateUrl: './notification.component.html',
    styleUrl: './notification.component.scss'
})
export class NotificationComponent implements OnInit {
    referralContacts: ReferralContact[] = [];
    displayedColumns: string[] = ['select', 'contactId', 'contactName', 'jurisdiction', 'status'];
    selectedItems: ReferralContact[] = [];
    showProgress: boolean = true;
    downloadPdfBtn: boolean = false;
    constructor(private referralNotificationService: ReferralNotificationService,
        private documentService: UploadDocumentService,
        private snackBar: SnackbarService) {
    }

    ngOnInit() {
        this.getReferralContacts();
    }

    getReferralContacts() {
        this.referralNotificationService.getReferredContacts().subscribe(
            res => {
                this.referralContacts = res || [];
                this.showProgress = false;
            },
            error => {
                this.snackBar.errorSnackBar(error.error.errors[0].message);
                this.showProgress = false;
            }
        )
    }

    toggleSelection(selectedContact: ReferralContact) {
        if (this.selectedItems.includes(selectedContact)) {
            this.selectedItems = this.selectedItems.filter(c => c.verificationId != selectedContact.verificationId);
        } else {
            this.selectedItems.push(selectedContact);
        }
    }

    isSelected(selectedContact: ReferralContact): boolean {
        return this.selectedItems.includes(selectedContact);
    }

    toggleSelectAll(event: any) {
        if (event.checked) {
            this.selectedItems = this.referralContacts;
        } else {
            this.selectedItems = [];
        }
    }

    isAllSelected(): boolean {
        return this.referralContacts.length > 0 && this.selectedItems.length === this.referralContacts.length;
    }

    isSomeSelected(): boolean {
        return this.selectedItems.length > 0 && !this.isAllSelected();
    }

    async upload() {
        this.showProgress = true;
        await firstValueFrom(this.documentService.uploadPdfs(this.selectedItems)).then(res => {
            if (res) {
                this.snackBar.successSnackBar("Documents uploaded!");
                this.referralContacts = [];
                this.getReferralContacts();
            }
            else {
                this.showProgress = false;
                this.snackBar.errorSnackBar("'Client File' matter not found.  Download the PDF and upload to the matter in Actionstep manually.");
                this.downloadPdfBtn = true;
            }
        }).catch(error => {
            this.showProgress = false;
            this.snackBar.errorSnackBar(error.error.errors[0].message);
            this.downloadPdfBtn = true;
        })
    }

    async downloadPdf() {
        this.documentService.downlaodFile(this.selectedItems[0].verificationId, "idverification").subscribe(file => {
            this.documentService.saveFile(file);
            this.downloadPdfBtn = false;
            this.referralContacts = [];
            this.getReferralContacts();
        },
            (error: any) => {
                this.snackBar.errorSnackBar("Failed to generate PDF.");
            }
        )
    }
}
